<section>
    @if (filtersForm) {
        @if (isTabletOrLower()) {
            <ng-container *ngTemplateOutlet="mobileViewTemplate" />
        } @else {
            <ng-container *ngTemplateOutlet="desktopViewTemplate" />
        }
    }
</section>

<ng-template #mobileViewTemplate>
    @if (!initialLoading()) {
        <div class="product-list-filters__mobile-links">
            <button
                class="product-list-filters__mobile-link primary-cta"
                type="button"
                (click)="onOpenMobileSelect('filter')"
            >
                Filter by
                <mat-icon class="caret-down" svgIcon="ico_caret_down" />
            </button>
            @if (isSortingActive()) {
                <button
                    class="product-list-filters__mobile-link primary-cta"
                    type="button"
                    (click)="onOpenMobileSelect('sort')"
                >
                    Sort
                    <mat-icon class="caret-down" svgIcon="ico_caret_down" />
                </button>
            }
        </div>

        @if (isPointsRange()) {
            <ng-container *ngTemplateOutlet="pointsRangeFilter"></ng-container>
        }
    } @else {
        <div class="product-list-filters__mobile-links-loader">
            <ng-container *ngTemplateOutlet="skeletonService.rectangleTemplate()"></ng-container>
        </div>
    }
</ng-template>

<ng-template #desktopViewTemplate>
    @if (!initialLoading() && filtersForm) {
        <form class="product-list-filters" [formGroup]="filtersForm">
            <div class="product-list-filters__left-column">
                <div style="display: flex; align-items: center">
                    <ng-container *ngTemplateOutlet="filtersTemplate" />
                </div>

                @if (brandsControl?.value?.length || categoryControl?.value?.length) {
                    <div class="product-list-filters__multi-selected">
                        @if (brandsControl?.value?.length) {
                            @for (value of brandsControl.value; track value) {
                                @if (value) {
                                    <lib-tag
                                        [class.disabled]="isSomeOptionsLoading()"
                                        [title]="brandsMap()[value]?.label"
                                        (closeEvent)="
                                            isSomeOptionsLoading() ? null : removeSelectedOptions(brandsControl, value)
                                        "
                                    />
                                }
                            }
                        }
                        @if (categoryControl?.value?.length) {
                            @for (value of categoryControl.value; track value) {
                                @if (value) {
                                    <lib-tag
                                        [class.disabled]="isSomeOptionsLoading()"
                                        [title]="categoriesMap()[value]?.label"
                                        (closeEvent)="
                                            isSomeOptionsLoading()
                                                ? null
                                                : removeSelectedOptions(categoryControl, value)
                                        "
                                    />
                                }
                            }
                        }
                        @if (getSelectedLength(brandsControl) || getSelectedLength(categoryControl)) {
                            <button
                                mat-button
                                disableRipple
                                [disabled]="isSomeOptionsLoading()"
                                (click)="resetFilters()"
                            >
                                <span class="product-list-filters__multi-selected-clear">Clear all</span>
                            </button>
                        }
                    </div>
                }
            </div>

            <div class="product-list-filters__right-column">
                <div class="product-list-filters__row">
                    @if (isSortingActive()) {
                        <div class="product-list-filters__sort">
                            <ng-container
                                *ngTemplateOutlet="
                                    formSelectTemplate;
                                    context: {
                                        control: sortingControl,
                                        filter: 'sortBy',
                                        title: 'Sorting',
                                        options: options.sortBy(),
                                    }
                                "
                            />
                        </div>
                    }
                </div>
                @if (isPointsRange()) {
                    <ng-container *ngTemplateOutlet="pointsRangeFilter"></ng-container>
                }
            </div>
        </form>
    } @else {
        <div class="product-list-filters__desktop-loader">
            <ng-container *ngTemplateOutlet="skeletonService.rectangleTemplate()"></ng-container>
        </div>
    }
</ng-template>

<ng-template #filtersTemplate>
    @for (filter of activeFilters(); track $index) {
        @switch (filter) {
            @case ('brandIds') {
                @if (hasBrandOptions()) {
                    <ng-container
                        *ngTemplateOutlet="
                            formSelectTemplate;
                            context: {
                                control: brandsControl,
                                filter: filter,
                                title: 'Brand',
                                options: options.brandIds(),
                                multiple: true,
                                apply: true,
                            }
                        "
                    />
                }
            }
            @case ('gender') {
                <ng-container
                    *ngTemplateOutlet="
                        formSelectTemplate;
                        context: { control: genderControl, filter: filter, title: 'Gender', options: options.gender() }
                    "
                />
            }
            @case ('category') {
                <ng-container
                    *ngTemplateOutlet="
                        formSelectTemplate;
                        context: {
                            control: categoryControl,
                            filter: filter,
                            title: 'Category',
                            options: options.category(),
                            multiple: true,
                            apply: true,
                        }
                    "
                />
            }
            @case ('color') {
                <ng-container
                    *ngTemplateOutlet="
                        formSelectTemplate;
                        context: { control: colorControl, filter: filter, title: 'Color', options: options.color() }
                    "
                />
            }
        }
    }
</ng-template>

<ng-template
    #formSelectTemplate
    let-apply="apply"
    let-control="control"
    let-filter="filter"
    let-multiple="multiple"
    let-options="options"
    let-title="title"
>
    @if (isTabletOrLower()) {
        <lib-mobile-select [formControl]="control" [multiple]="multiple" [options]="options" [title]="title" />
    } @else {
        <label
            [id]="labelIdByFilter(filter)"
            class="cta"
            [ariaLabel]="ariaLabelByControl(filter)"
            [for]="controlIdByFilter(filter)"
        >
            {{ labelByFilter(filter) }}
        </label>
        <mat-form-field>
            <mat-select
                [id]="controlIdByFilter(filter)"
                class="primary-cta"
                #select="matSelect"
                [aria-labelledby]="labelIdByFilter(filter)"
                [formControl]="control"
                [multiple]="multiple"
                [panelClass]="apply ? 'apply-panel' : ''"
                [placeholder]="title"
            >
                @if (multiple) {
                    <mat-select-trigger>
                        @if (control.value?.length) {
                            {{ title }}
                            @if (getSelectedLength(control); as length) {
                                <p class="product-list-filters__trigger-count body-2">
                                    {{ length }}
                                </p>
                            }
                        }
                    </mat-select-trigger>
                }
                <div class="apply-panel__options">
                    @for (option of options; track option.value) {
                        <mat-option class="primary-cta" [ariaLabel]="option.ariaLabel" [value]="option.value">{{
                            option.label
                        }}</mat-option>
                    }
                    @if (options.length === 0) {
                        <mat-option class="primary-cta product-list-filters__no-options" disabled
                            >No options</mat-option
                        >
                    }
                </div>
                @if (apply) {
                    <mat-option
                        class="product-list-filters__apply-btn"
                        [disabled]="options.length === 0"
                        (onSelectionChange)="emitFormValue(); select.close()"
                    >
                        <button mat-raised-button role="option" [disabled]="options.length === 0">Apply</button>
                    </mat-option>
                }
            </mat-select>
            <mat-icon
                class="caret-down"
                svgIcon="ico_caret_down"
                [ngClass]="{ 'upside-down': select.panelOpen }"
            ></mat-icon>
        </mat-form-field>
    }
</ng-template>

<ng-template #overlayTemplate>
    @switch (openedMobileTemplate()) {
        @case ('filter') {
            <ng-container [ngTemplateOutlet]="filtersOverlayTemplate" />
        }
        @case ('sort') {
            <ng-container [ngTemplateOutlet]="sortOverlayTemplate" />
        }
    }
</ng-template>

<ng-template #filtersOverlayTemplate>
    <lib-mobile-overlay>
        <ng-container overlay-header>
            <lib-navigation-menu-header title="Filter by" (closeEvent)="onCloseMobileMenu()" />
        </ng-container>

        <ng-container overlay-body>
            <div class="product-list-filters__mobile-filters">
                <ng-container *ngTemplateOutlet="filtersTemplate" />
            </div>
        </ng-container>

        <ng-container overlay-footer>
            <button mat-stroked-button class="product-list-filters__action" type="button" (click)="resetFilters()">
                Clear All
            </button>
            <button mat-raised-button class="product-list-filters__action" type="button" (click)="onApplyFilters()">
                Apply
            </button>
        </ng-container>
    </lib-mobile-overlay>
</ng-template>

<ng-template #sortOverlayTemplate>
    <lib-mobile-overlay>
        <ng-container overlay-header>
            <lib-navigation-menu-header title="Sort by" (closeEvent)="onCloseMobileMenu()" />
        </ng-container>

        <ng-container overlay-body>
            <div class="product-list-filters__mobile-sort">
                <lib-mobile-select
                    aria-label="Sort by selection"
                    title="Sort By"
                    [formControl]="sortingControl"
                    [hasHeader]="false"
                    [opened]="true"
                    [options]="options.sortBy() | appIsArray"
                />
            </div>
        </ng-container>

        <ng-container overlay-footer>
            <button
                mat-stroked-button
                class="product-list-filters__action product-list-filters__action--apply"
                (click)="onApplyFilters()"
            >
                Apply
            </button>
        </ng-container>
    </lib-mobile-overlay>
</ng-template>

<ng-template #pointsRangeFilter>
    <div class="product-list-filters__row product-list-filters__row--points-range">
        <label
            [id]="labelIdByFilter('isAvailablePointsRange')"
            class="primary-cta"
            [for]="controlIdByFilter('isAvailablePointsRange')"
        >
            Only show items in my {{ rewardName() }} range
        </label>
        <mat-slide-toggle
            [id]="controlIdByFilter('isAvailablePointsRange')"
            aria-label="Toggle"
            [aria-labelledby]="labelIdByFilter('isAvailablePointsRange')"
            [formControl]="isAvailablePointsRangeControl"
        />
    </div>
</ng-template>
